import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {GetOrganizationsRequest, GetSelfOrganizationRequest, Organization, PostOrganizationRequest} from '../models/organization';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/internal/operators';
import {throwError} from 'rxjs/index';
import gql from 'graphql-tag';
import {Apollo} from 'apollo-angular';
import {ApolloQueryResult} from 'apollo-client';

@Injectable()
export class OrganizationService {

  constructor(private httpClient: HttpClient,
              private apollo: Apollo) {
  }

  postOrganization({accessToken, orgName}: PostOrganizationRequest): Observable<Organization> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    });
    const url = `${environment.afbV2Host}orgs`;
    const body = {orgName};

    return this.httpClient
      .post<Organization>(url, body, {headers});
  }

  getOrganizations({accessToken}: GetOrganizationsRequest): Observable<Organization[]> {
    const query = gql`
      query q {
        orgs {
          id
          name
          isActivated
          role
          numberOfDevices
        }
      }
    `;
    const headers = {
      Authorization: `Bearer ${accessToken}`
    };
    return this.apollo.query({
        query,
        context: {headers}
      }
    ).pipe(
      map((response: ApolloQueryResult<{ orgs: Organization[] }>) => {
        return response.data.orgs;
      }),
      catchError((error: HttpErrorResponse) => throwError(error))
    );
  }

  getSelfOrganization({organizationToken}: GetSelfOrganizationRequest): Observable<Organization> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${organizationToken}`});
    const url = `${environment.afbV2Host}org-users/self/org`;

    return this.httpClient
      .get<Organization>(url, {headers});
  }
}
